import { render, staticRenderFns } from "./tUserForm.vue?vue&type=template&id=2592de2c&scoped=true"
import script from "./tUserForm.vue?vue&type=script&lang=js"
export * from "./tUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592de2c",
  null
  
)

export default component.exports